import { render, staticRenderFns } from "./ProcessingFee.vue?vue&type=template&id=1578a9f6&scoped=true"
import script from "./ProcessingFee.vue?vue&type=script&lang=js"
export * from "./ProcessingFee.vue?vue&type=script&lang=js"
import style0 from "./ProcessingFee.vue?vue&type=style&index=0&id=1578a9f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1578a9f6",
  null
  
)

export default component.exports